import { Typography } from "@mui/material"
import type { FC, ReactNode } from "react"
import { twMerge } from "tailwind-merge"

interface LabelValueProps {
  label: string
  value: ReactNode
  labelClassName?: string
  valueClassName?: string
}

export const LabelValue: FC<LabelValueProps> = ({ label, value, labelClassName, valueClassName }) => {
  return (
    <Typography variant='body2' className={twMerge("font-bold text-gray-700", labelClassName)}>
      {label}:{" "}
      <Typography component='span' variant='body2' className={twMerge("font-normal text-gray-700", valueClassName)}>
        {value}
      </Typography>
    </Typography>
  )
}
